import React, { useEffect, useState } from 'react'
import { Modal, Spin, Typography } from 'antd'
import { withTranslation } from 'react-i18next'
import QRCode from 'react-qr-code'
import apiService from '../../Auth/apiService'


const { Paragraph } = Typography

const ScanUploadImagesLinkModal = ({ payload, visible, t, onCancel, router_path, title, hints = [1, 4] }) => {
    const [loading, setLoading] = useState(false)
    const [token, setToken] = useState('')
    const [url, setUrl] = useState('')

    const getToken = async () => {
        setLoading(true)
        try {
            const { data } = await apiService.getLimitedTimeToken()
            setToken(data)
        } catch (error) {}
        setLoading(false)
    }

    useEffect(() => {
        if (visible) {
            getToken()
        }
    }, [visible])

    useEffect(() => {
        const queryString = new URLSearchParams(payload).toString()
        const url = `${window.location.origin}${router_path}?auth_token=${token}&${queryString}`

        setUrl(url)
    }, [payload, token])

    return (
        <Modal
            footer={null}
            title={title ? title : t('package:upload_damaged_product_images')}
            visible={visible}
            onCancel={onCancel}
            className="checking-package__modal-upload_damage_product-img">
            <div className="gflex amt-16">
                <div className="flex-shrink-0">
                    <Spin spinning={loading}>
                        <QRCode
                            size={200}
                            value={url}
                        />
                    </Spin>
                </div>
                <div className="aml-16">
                    {hints.map(hint => (
                        <Paragraph
                            className="mb-0"
                            key={hint}>
                            {t(`package:scan_upload_image_hints.${hint}`)}
                        </Paragraph>
                    ))}
                </div>
            </div>
        </Modal>
    )
}

export default withTranslation()(ScanUploadImagesLinkModal)
